import { TestimonialCard } from "./TestimonialCard";

export const Testimonials = () => {
  return (
    <section className="bg-white py-20 sm:py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mx-auto mb-14 max-w-2xl text-center">
          <span className="text-xs font-bold uppercase tracking-[0.25em] text-brand-600">
            Testimonials
          </span>
          <h2 className="mt-3 font-display text-4xl font-semibold text-slate-900 sm:text-5xl">
            Client Testimonials
          </h2>
          <p className="mt-4 text-lg text-slate-600">
            Don’t take our word for it – here’s what our clients say:
          </p>
        </div>
        <div className="grid gap-8 md:grid-cols-3">
          <TestimonialCard
            text="Snehal Jadhav, is just excellent. She very well understands her clients and counsel accordingly. She is very professional in her work she does and a hard working person. 😊 I would definitely recommend people to her as she has solution to all the problems.. Highly recommended…! 👍👍👍"
            name="Karishma Yande"
          />
          <TestimonialCard
            text="I am very thankful to Mrs.Snehal for all the help. she calmly listened to me without being judgemental and always told me the right way out. Talking to her made me understand the fears i was carrying all this while and how it affected my thinking pattern. She guided me on how to change that pattern. Now i am able to trust people, be less guarded and more open to life."
            name="Nikita Dhalkari"
          />
          <TestimonialCard
            text="I had a great experience with Snehal ma’am. She is very understanding. I could talk to her freely because she’s great at making clients comfortable. I highly recommend this place for anyone seeking overall betterment of their mental health!"
            name="Arnavi"
          />
        </div>
      </div>
    </section>
  );
};
